/* eslint-disable @typescript-eslint/no-explicit-any */
function isMyToniesProd() {
    return (typeof globalThis === 'object' &&
        typeof globalThis.runtimeEnvVars === 'object' &&
        globalThis.runtimeEnvVars.REACT_APP_ENVIRONMENT === 'prod');
}
function isTestEnvironment() {
    return (typeof globalThis === 'object' &&
        typeof globalThis.process === 'object' &&
        typeof globalThis.process.env === 'object' &&
        // process.env.NODE_ENV will be replaced by rollup with 'production'
        globalThis.process.env['NODE_ENV'] === 'test');
}
export function deprecate(fn, message) {
    let warned = false;
    return (...args) => {
        if (!warned && !isMyToniesProd() && !isTestEnvironment()) {
            warned = true;
            console.warn(message);
        }
        return fn(...args);
    };
}
